import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const CheckoutIcon = ({ ariaLabel = 'Checkout success', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox={`0 0 ${size || width} ${size || height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 40C0 17.9431 17.9446 0 40 0C62.0554 0 80 17.9431 80 40C80 62.0569 62.0554 80 40 80C17.9446 80 0 62.0569 0 40ZM3.07692 40C3.07692 60.3585 19.6415 76.9231 40 76.9231C60.3585 76.9231 76.9231 60.3585 76.9231 40C76.9231 19.6415 60.3585 3.07692 40 3.07692C19.6415 3.07692 3.07692 19.6415 3.07692 40Z"
        fill="#14C541"
      />
      <path
        d="M58.8492 23.5939L35.2046 50.1939L20.96 38.7985C20.2985 38.2677 19.3277 38.3769 18.7985 39.0385C18.2677 39.7031 18.3754 40.6708 19.0385 41.2015L34.4231 53.5092C34.7062 53.7354 35.0462 53.8462 35.3846 53.8462C35.8092 53.8462 36.2323 53.6708 36.5354 53.3292L61.1508 25.6369C61.7154 25.0031 61.6585 24.0292 61.0231 23.4662C60.3862 22.9 59.4154 22.9569 58.8492 23.5939Z"
        fill="#14C541"
      />
    </svg>
  );
};
